<template>
   <div id="app">
    <transition name="fade">
      <router-view></router-view>
    </transition>
   </div>
</template>
<style>
@import url('@/assets/css/style.css');
</style>
<script>
export default {
  name: 'App'
}
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.75s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>